import {
  FiLink,
  FiFileText,
  FiCpu,
  FiBook,
  FiColumns,
  FiDownload,
} from "react-icons/fi";

export const wizardSteps = [
  { id: "mapping", title: "Mapping", icon: FiLink },
  { id: "documents", title: "Documents", icon: FiFileText },
  { id: "process", title: "Process", icon: FiCpu },
  { id: "vocabulary", title: "Vocabulary", icon: FiBook },
  { id: "comparison", title: "Compare", icon: FiColumns },
  { id: "download", title: "Download", icon: FiDownload },
];

export const documentTypes = [
  { id: "test-script", name: "Test Script", description: "Validation test scripts" },
  { id: "sop-document", name: "SOP Document", description: "Standard operating procedure documents" },
];
